<template>
  <div>
    <PageAllow controller="Coupons" :action="savable ? 'add' : 'view'" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          <span v-if="savable">
            {{ $t("MaterialCoupons.newInfo") }}
          </span>
          <span v-else>
            {{ $t("MaterialCoupons.viewInfo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="$router.push('/material-coupons')"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("MaterialCoupons.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <!-- 优惠券名称 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialCoupons.Fields.name") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialCoupons.Fields.name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="coupons.name"
                      :error-messages="errors"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ coupons.name }}
                </v-col>
              </v-row>
              <!-- 优惠券类型 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialCoupons.Fields.type") + $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-row class="pl-3" v-if="savable">
                    <v-radio-group row v-model="coupons_type">
                      <v-radio
                        v-for="type in couponsTypeItems"
                        class="mt-n2"
                        :key="type.value"
                        :label="`${type.text}`"
                        :value="type.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <v-row class="pl-3" v-else>
                    {{ coupons.type_str }}
                  </v-row>
                </v-col>
              </v-row>
              <!-- 发放数量 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.distribution") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialCoupons.Fields.distribution')"
                    :rules="{
                      min_value: {
                        min: 1,
                      },
                      required: {
                        required: true,
                      },
                    }"
                  >
                    <v-text-field
                      single-line
                      v-model="coupons.num"
                      type="number"
                      min="0"
                      :error-messages="errors"
                      :suffix="$t('MaterialCoupons.Unit.piece')"
                      @blur="
                        coupons.num != ''
                          ? (coupons.num = $numberFormatter.formatNoDot(
                              coupons.num
                            ))
                          : ''
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span v-if="coupons.num">
                    {{ coupons.num + $t("MaterialCoupons.Unit.piece") }}
                  </span>
                </v-col>
              </v-row>
              <!-- 使用门槛 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.use_type") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row class="pl-3">
                    <v-radio-group row v-model="use_type">
                      <v-radio
                        v-for="type in couponsUseTypeItems"
                        class="mt-n2"
                        :key="type.value"
                        :label="`${type.text}`"
                        :value="type.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <!-- 优惠立减 -->
                  <v-row class="pl-3">
                    <v-col cols="4" md="4">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialCoupons.Fields.use_type')"
                        :rules="
                          use_type == 1
                            ? {
                                min_value: {
                                  min: 0.01,
                                },
                                required: {
                                  required: true,
                                },
                              }
                            : ''
                        "
                      >
                        <v-text-field
                          v-model="rule_price"
                          type="number"
                          min="0"
                          :disabled="use_type == 2"
                          :error-messages="errors"
                          :suffix="$t('MaterialCoupons.Unit.yuan')"
                          @blur="
                            rule_price != ''
                              ? (rule_price =
                                  $numberFormatter.formatMoney(rule_price))
                              : ''
                          "
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-row align="center" class="ml-15">
                      <span v-if="coupons_type == 1">{{
                        $t("MaterialCoupons.Fields.discount")
                      }}</span>
                      <span v-else-if="coupons_type == 2">{{
                        $t("MaterialCoupons.Fields.offers")
                      }}</span>
                      <span>{{ $t("Global.colon") }}</span>
                      <Required :show="savable" :mode="mode" />
                    </v-row>
                    <v-col cols="4" md="4">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialCoupons.Fields.discount')"
                        :rules="couponPriceRules"
                      >
                        <v-text-field
                          v-model="coupons.coupon_price"
                          type="number"
                          min="0"
                          :error-messages="errors"
                          :suffix="
                            coupons_type == 1
                              ? $t('MaterialCoupons.Unit.yuan')
                              : $t('MaterialCoupons.Unit.offers')
                          "
                          @blur="
                            coupons.coupon_price != ''
                              ? (coupons.coupon_price =
                                  $numberFormatter.formatMoney(
                                    coupons.coupon_price
                                  ))
                              : ''
                          "
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ coupons.coupon_content }}
                </v-col>
              </v-row>
              <!-- 适用商品 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.for_material") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-row class="pl-3" v-if="savable">
                    <v-radio-group row v-model="material_type">
                      <v-radio
                        v-for="stat in materialsTypeItems"
                        class="mt-n2"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <span v-else>
                    {{ material_type | couponMaterialTypesText }}
                  </span>

                  <div class="mt-2" v-if="material_type == 1">
                    <!-- 选择分类 -->
                    <v-btn
                      v-if="savable"
                      color="primary"
                      class="my-1 mr-3"
                      small
                      outlined
                      @click="category_dialog = true"
                    >
                      {{ $t("CRUD.chooseInfo", [$t("Campaigns.category")]) }}
                    </v-btn>
                    <br />
                    <v-data-table
                      :headers="categoryHeaders"
                      :items="categories"
                      multi-sort
                      class="elevation-1 px-4 pt-2"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <!-- 删除商品按钮 -->
                        <v-btn
                          small
                          text
                          class="danger--text pa-0"
                          @click="
                            categories.splice(
                              categories.findIndex(
                                (category) => category.id == item.id
                              ),
                              1
                            )
                          "
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </div>
                  <div class="mt-2" v-if="material_type == 2">
                    <!-- 选择商品 -->
                    <v-btn
                      v-if="savable"
                      color="primary"
                      class="my-1 mr-3"
                      small
                      outlined
                      @click="materials_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("Campaigns.Fields.materials"),
                        ])
                      }}
                    </v-btn>
                    <br />
                    <v-data-table
                      :headers="materialHeaders"
                      :items="materialItems"
                      :loading="materialsLoading"
                      multi-sort
                      class="elevation-1 px-4 pt-2"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:item.Description="{ item }">
                        <span>{{ item.material_name }}</span>
                        <br />
                        <span class="caption secondary--text">
                          {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                          <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                            {{ item.standard_name.slice(0, 12) + "......" }}
                          </span>
                          <span v-else>
                            {{ item.standard_name }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <!-- 删除商品按钮 -->
                        <v-btn
                          small
                          text
                          class="danger--text pa-0"
                          @click="
                            materials.splice(
                              materials.findIndex(
                                (material) => material.id == item.id
                              ),
                              1
                            )
                          "
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
              <!-- 适用客户 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.for_shop") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <span v-if="savable">
                    <v-btn
                      color="primary"
                      class="my-1 mr-3"
                      x-small
                      outlined
                      @click="districts_dialog = true"
                      v-if="district_type == 1"
                    >
                      {{ $t("CRUD.chooseInfo", [$t("Campaigns.districts")]) }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="my-1 mr-3"
                      x-small
                      outlined
                      @click="shops_dialog = true"
                      v-if="district_type == 2"
                    >
                      {{ $t("CRUD.chooseInfo", [$t("Campaigns.shops")]) }}
                    </v-btn>
                    <!-- <br />
                    <span class="text-caption">
                      {{ $t("MaterialOrderRule.Fields.districts_hint") }}
                    </span> -->
                  </span>
                </v-col>
                <!-- 适用组别 -->
                <v-col cols="9" md="7">
                  <v-row class="pl-3" v-if="savable">
                    <v-radio-group row v-model="district_type">
                      <v-radio
                        v-for="stat in districtsTypeItems"
                        class="mt-n2"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <span v-else>
                    {{ district_type | couponDistrictTypesText }}
                  </span>
                  <v-data-table
                    :headers="districtHeaders"
                    :items="districts"
                    :loading="districtsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                    v-if="district_type == 1"
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          districts.splice(
                            districts.findIndex(
                              (district) => district.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <v-data-table
                    :headers="shopHeaders"
                    :items="shops"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                    v-if="district_type == 2"
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          shops.splice(
                            shops.findIndex((shop) => shop.id == item.id),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 有效期 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.prescription_type") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row class="pl-3">
                    <v-radio-group row v-model="prescription_type">
                      <v-radio
                        v-for="type in couponsPrescriptionTypeItems"
                        class="mt-n2"
                        :key="type.value"
                        :label="`${type.text}`"
                        :value="type.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <v-row class="pl-3" v-if="prescription_type == 1">
                    <v-col cols="5" md="9">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('MaterialCoupons.Fields.prescription_type')"
                        :rules="{
                          min_value: {
                            min: 1,
                          },
                          required: {
                            required: true,
                          },
                        }"
                      >
                        <v-text-field
                          single-line
                          v-model="coupons.days"
                          type="number"
                          min="0"
                          :error-messages="errors"
                          :suffix="$t('MaterialCoupons.Unit.days')"
                          @blur="
                            coupons.days != ''
                              ? (coupons.days = $numberFormatter.formatNoDot(
                                  coupons.days
                                ))
                              : ''
                          "
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="pl-3" v-if="prescription_type == 2">
                    <v-col cols="5" md="5">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('Campaigns.Fields.date_from')"
                        rules="required"
                      >
                        <SearcherDatetime
                          class="my-n2"
                          v-model="coupons.valid_start_date"
                          type="date"
                          single-line
                          dense
                          hide-details
                          hide-icon
                          disabledBeforeToday
                          required
                          :errors="errors"
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </SearcherDatetime>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="1" class="text-center">~</v-col>
                    <v-col cols="5" md="5">
                      <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('Campaigns.Fields.date_to')"
                        rules="required"
                      >
                        <SearcherDatetime
                          class="my-n2"
                          v-model="coupons.valid_end_date"
                          type="date"
                          single-line
                          dense
                          hide-details
                          hide-icon
                          disabledBeforeToday
                          required
                          :errors="errors"
                        >
                          <template v-slot:message="{ key, message }">
                            <div :class="key == 0 ? 'danger--text' : ''">
                              {{ message }}
                            </div>
                          </template>
                        </SearcherDatetime>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span v-if="coupons.prescription_type == 1">
                    {{ coupons.days + $t("MaterialCoupons.Unit.days") }}
                  </span>
                  <span v-if="coupons.prescription_type == 2">
                    {{ coupons.valid_start_date | formatDate }}
                    ~
                    {{ coupons.valid_end_date | formatDate }}
                  </span>
                </v-col>
              </v-row>
              <!-- 每个客户限领取数 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.confine_num_title") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row class="pl-3">
                    <v-radio-group row v-model="confine_flg">
                      <v-radio
                        v-for="type in couponsNewFlgItems"
                        class="mt-n2"
                        :key="type.value"
                        :label="`${type.text}`"
                        :value="type.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <v-row class="pl-3" v-if="confine_flg == 1">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('MaterialCoupons.Fields.confine_num_title')"
                      :rules="{
                        min_value: {
                          min: 1,
                        },
                        required: {
                          required: true,
                        },
                      }"
                    >
                      <v-text-field
                        single-line
                        v-model="coupons.confine_num"
                        type="number"
                        min="0"
                        :error-messages="errors"
                        :suffix="$t('MaterialCoupons.Unit.piece')"
                        @blur="
                          coupons.confine_num != ''
                            ? (coupons.confine_num =
                                $numberFormatter.formatNoDot(
                                  coupons.confine_num
                                ))
                            : ''
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span v-if="coupons.confine_flg == 0">
                    {{ $t("MaterialCoupons.NewFlg.no_restriction") }}
                  </span>
                  <span v-else>
                    <span v-if="coupons.confine_num">
                      {{
                        coupons.confine_num + $t("MaterialCoupons.Unit.piece")
                      }}
                    </span>
                  </span>
                </v-col>
              </v-row>
              <!-- 是否仅限新客户领取 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.is_restriction") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row class="pl-3">
                    <v-radio-group row v-model="coupons.new_flg">
                      <v-radio
                        v-for="type in couponsNewFlgItems"
                        class="mt-n2"
                        :key="type.value"
                        :label="`${type.text}`"
                        :value="type.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span v-if="coupons.new_flg == 0">
                    {{ $t("MaterialCoupons.NewFlg.no_restriction") }}
                  </span>
                  <span v-else>
                    {{ $t("MaterialCoupons.NewFlg.restriction") }}
                  </span>
                </v-col>
              </v-row>
              <!-- 分账类型 -->
              <v-row
                v-if="
                  settings &&
                  settings.sub_account_enable == 1 &&
                  settings.sub_account_split_type == 0 &&
                  coupons_type == 1
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialCoupons.Fields.sub_account_type") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row class="pa-3 pt-1">
                    <SearcherSubAccountType
                      v-model="sub_account_type"
                      noLabel
                      dense
                    ></SearcherSubAccountType>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ coupons ? coupons.sub_account_type_name : "" }}
                </v-col>
              </v-row>
              <!-- 使用说明 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("MaterialCoupons.Fields.comment") }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-textarea outlined v-model="coupons.content"></v-textarea>
                </v-col>
                <v-col v-else>
                  {{ coupons.content }}
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- 右侧按钮 -->
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="$router.push('/material-coupons')"
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{
                    $t("CRUD.backToList", [$t("MaterialCoupons.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  v-if="savable"
                  color="success"
                  block
                  :disabled="loading"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("MaterialCoupons.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    <DialogDistricts
      v-model="districts_dialog"
      :districtSelected="districts"
      @confirm="districts = $event"
    />
    <DialogShops
      v-model="shops_dialog"
      :shopSelectedId="shops ? shops.map((e) => {return e.id;}) : []"
      @add="addShop($event)"
      @confirm="shops = $event"
    />
    <DialogCategories
      v-model="category_dialog"
      :categorySelected="categories"
      @confirm="categories = $event"
    />
    <MaterialsSelectsDialog
      v-model="materials_dialog"
      :materialIds="materialIds"
      @confirm="choosedMaterials = $event"
    />
    <DialogMaterial
      v-model="selectMaterialDialog"
      @confirm="
        selectMaterial = $event;
        selectMaterials();
      "
      isActivity
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Required from "@/components/plugins/Required";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
import DialogDistricts from "@/components/plugins/DialogDistricts";
import DialogShops from "@/components/plugins/DialogShops";
import DialogCategories from "@/components/plugins/DialogCategories";
import DialogMaterial from "@/components/plugins/DialogMaterial";
import Coupons from "@/api/coupons";
import Consts from "@/consts.js";
import SearcherSubAccountType from "@/components/subAccountSettings/plugins/SearcherSubAccountType";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
    Required,
    SearcherDatetime,
    MaterialsSelectsDialog,
    DialogDistricts,
    DialogMaterial,
    DialogShops,
    DialogCategories,
    SearcherSubAccountType,
  },

  computed: {
    items() {
      var item = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.materialCoupons"),
          disabled: false,
          href: "/material-coupons",
        },
      ];
      if (this.mode == "new") {
        item.push({
          text: i18n.t("MaterialCoupons.newInfo"),
          disabled: true,
          href: "/material-coupons",
        });
      }

      return item;
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },
    savable() {
      return this.mode == "new" || this.mode == "clone";
    },
    Type() {
      return this.$route.query.type;
    },
    districtHeaders() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.district_code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.district_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    shopHeaders() {
      var headers = [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    categoryHeaders() {
      var headers = [
        {
          text: i18n.t("Campaigns.Fields.categories_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    materialItems() {
      return this.materials.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },
    materialHeaders() {
      var materialHeaders = [
        {
          text: i18n.t("MaterialOrderRule.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "material_category.name",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "Description",
        },
      ];

      if (this.savable) {
        materialHeaders.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return materialHeaders;
    },
    districtsTypeItems() {
      return Consts.coupons.coupon_district_types;
    },
    materialsTypeItems() {
      return Consts.coupons.coupon_material_types;
    },
    couponsTypeItems() {
      return Consts.coupons.coupon_type;
    },
    couponsPrescriptionTypeItems() {
      return Consts.coupons.prescription_type;
    },
    couponsNewFlgItems() {
      return Consts.coupons.new_flg;
    },
    couponsUseTypeItems() {
      return Consts.coupons.use_type;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    mode: "",
    coupons: {},
    use_type: 1,
    coupons_type: 1,
    rule_price: "",
    prescription_type: 1,
    confine_flg: 1,
    submit_data: {},
    districts_dialog: false,
    shops_dialog: false,
    materials_dialog: false,
    selectMaterialDialog: false,
    category_dialog: false,
    materialsLoading: false,
    districtsLoading: false,
    selectMaterial: {},
    shops: [],
    districts: [],
    materialIds: [],
    choosedMaterials: [],
    categories: [],
    materials: [],
    material_type: 0,
    district_type: 0,
    couponPriceRules: {},
    sub_account_type: null,
  }),

  mounted() {
    if (this.$route.path.startsWith("/material-coupons/detail/new")) {
      this.mode = "new";
      this.coupons_type = 1;
      this.coupons.new_flg = 1;
      this.coupons.num = "";
      this.rule_price = "";
      this.coupons.coupon_price = "";
      this.coupons.days = "";
      this.coupons.confine_num = "";
      this.sub_account_type = null;
      this.getCouponPriceRules();
    } else {
      this.mode = this.$route.params.mode ? this.$route.params.mode : "view";
      this.getCouponsFromAPI(this.$route.params.id);
    }
  },

  methods: {
    getCouponsFromAPI(id) {
      Coupons.fetchOne(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.coupons = response.data.coupon;

            // 适用商品明细初始化设置
            this.material_type = this.coupons.material_type;
            this.coupons_type = this.coupons.type;
            this.rule_price = this.coupons.rule_price
            this.prescription_type = this.coupons.prescription_type
            this.confine_flg = this.coupons.confine_flg
            this.sub_account_type = this.coupons.sub_account_type
            this.use_type = this.coupons.use_type

            if (this.material_type == 1) {
              // 指定分类
              this.categories = this.coupons.material_category_list.map(
                (item) => {
                  return {
                    code: item.code,
                    name: item.name,
                  };
                }
              );
            }
            if (this.material_type == 2) {
              // 指定商品
              this.materials = this.coupons.material_list
            }

            // 适用客户明细初始化
            this.district_type = this.coupons.shop_type;
            if (this.district_type == 1) {
              // 指定分组
              this.districts = this.coupons.district_list.map((item) => {
                return {
                  number: item.number,
                  code: item.code,
                  name: item.name,
                };
              });
            }
            if (this.district_type == 2) {
              // 指定客户
              this.shops = this.coupons.shop_list.map((item) => {
                return {
                  shop_code: item.shop_code,
                  shop_name: item.shop_name,
                };
              });
            }
            if (this.mode == "clone") { 
              if (this.coupons.prescription_type == 2) {
                  this.coupons.valid_start_date = "";
                  this.coupons.valid_end_date = "";
              }
            }
          }
        }.bind(this)
      );
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //整理提交数据
            this.submit_data = {
              name: this.coupons.name,
              type: this.coupons_type,
              num: this.coupons.num,
              use_type: this.use_type,
              rule_price: this.rule_price,
              coupon_price: this.coupons.coupon_price,
              material_type: this.material_type,
              shop_type: this.district_type,
              prescription_type: this.prescription_type,
              days: this.coupons.days,
              valid_start_date: this.coupons.valid_start_date,
              valid_end_date: this.coupons.valid_end_date,
              confine_flg: this.confine_flg,
              confine_num: this.coupons.confine_num,
              new_flg: this.coupons.new_flg,
              content: this.coupons.content,
            };

            // 适用商品
            if (this.material_type == 1) {
              // 指定分类
              let categories_code = this.categories
                ? this.categories.map((category) => {
                    return category.code;
                  })
                : [];
              this.submit_data = Object.assign({}, this.submit_data, {
                material_match: categories_code,
              });
            } else if (this.material_type == 2) {
              // 指定商品
              this.submit_data = Object.assign({}, this.submit_data, {
                material_match: this.materialIds,
              });
            }

            // 适用客户
            if (this.district_type == 1) {
              // 指定分组
              let districts_code = this.districts
                ? this.districts.map((district) => {
                    return district.code;
                  })
                : [];
              this.submit_data = Object.assign({}, this.submit_data, {
                shop_match: districts_code,
              });
            } else if (this.district_type == 2) {
              // 指定客户
              let shops_id = this.shops
                ? this.shops.map((shop) => {
                    return shop.id;
                  })
                : [];
              this.submit_data = Object.assign({}, this.submit_data, {
                shop_match: shops_id,
              });
            }
            if (
              this.settings &&
              this.settings.sub_account_enable == 1 &&
              this.settings.sub_account_split_type == 0 &&
              this.coupons_type == 1
            ) {
              this.submit_data = Object.assign({}, this.submit_data, {
                sub_account_type: this.sub_account_type.type,
              });
            }

            //接口提交保存
            if (this.mode == "new" || this.mode == "clone") {
              Coupons.addCoupons(this.submit_data)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$snackbar.success(
                        i18n.t("MaterialOrderRule.Messages.saveSuccess")
                      );
                      this.$router.replace("/material-coupons");
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    getCouponPriceRules() {
      if (this.coupons_type == 2) {
        this.couponPriceRules = {
          min_value: { min: 0.01 },
          max_value: { max: 9.99 },
          required: { required: true },
        };
      } else {
        if (this.use_type == 1) {
          this.couponPriceRules = {
            min_value: { min: 0.01 },
            max_value: { max: this.rule_price },
            required: { required: true },
          };
        } else {
          this.couponPriceRules = {
            min_value: { min: 0.01 },
            required: { required: true },
          };
        }
      }
    },
    addShop(shops) {
      shops.forEach((shop) => {
        this.shops.push(shop)
      })
    },
  },

  watch: {
    materials: {
      deep: true,
      handler() {
        if (this.materials.length) {
          this.materialIds = this.materials.map((material) => {
            return material.id;
          });
        } else {
          this.materialIds = [];
        }
      },
    },
    // 监听单次选择的商品
    choosedMaterials: {
      handler() {
        //  综合多次选择的商品
        this.choosedMaterials.forEach((material) => {
          this.materials.push(Object.assign({}, material));
        });
      },
    },
    rule_price: {
      handler() {
        this.getCouponPriceRules();
      },
    },
    coupons_type: {
      handler() {
        this.getCouponPriceRules();
      },
    },
    use_type: {
      handler() {
        if (this.use_type == 2) {
          this.rule_price = "";
        }
        this.getCouponPriceRules();
      },
    },
    prescription_type: {
      handler() {
        if (this.prescription_type == 1) {
          this.coupons.valid_start_date = "";
          this.coupons.valid_end_date = "";
        } else if (this.prescription_type == 2) {
          this.coupons.days = "";
        }
      },
    },
    confine_flg: {
      handler() {
        if (this.confine_flg == 0) {
          this.coupons.confine_num = "";
        }
      },
    },
  },
};
</script>